'use client';

import AboutTab from './about-tab';
import ConsentTab from './consent-tab';
import type { ConsentCategoryConfig } from './constants';
import DetailsTab from './details-tab';
import type { Tab } from './use-modal-state';

type Props = {
  activeTab: Tab;
  preferences: Record<ConsentCategoryConfig['id'], boolean>;
  onUpdate: (category: ConsentCategoryConfig['id'], value: boolean) => void;
};

const TabContent = ({ activeTab, preferences, onUpdate }: Props) => {
  if (activeTab === 'details') {
    return <DetailsTab preferences={preferences} onUpdate={onUpdate} />;
  }
  if (activeTab === 'about') {
    return <AboutTab />;
  }
  return <ConsentTab />;
};

export default TabContent;
